export const SUCCESS_STATIC="SUCCESS_STATIC";
export const FAILED_STATIC="FAILED_STATIC";
export const REQUST_STATIC="REQUST_STATIC";
